export const iconSizeClass = {
  small: 'w-8 h-8',
  medium: 'w-12 h-12',
  large: 'w-16 h-16',
};

export const variantClass = {
  filled: 'bg-blue-500 text-white',
  outline: 'border border-blue-500 text-blue-500',
};
